module.exports = "/_next/static/images/1ea74fa2f17c09cbf1c0683897637ae4-hero-desktop-large-v1.jpg";